const adminRequestsSplitView = {
  emptyState: "Engar gagnabeiðnir fyrir þetta verkefni ennþá.",
  filters: {
    allProjects: "Öll verkefni",
    allStatuses: "Allar stöður",
    allTypes: "Allar tegundir",
    sortNewest: "Nýjast fyrst",
    sortOldest: "Elst fyrst",
    sortStatusPriority: "Forgangsröðun eftir stöðu",
  },
  requestType: {
    access: "Aðgangsbeiðni",
    data: "Gagnabeiðni",
  },
  list: {
    noMatch: "Engar beiðnir samsvara þessum síum.",
    fallbackUser: "Notandi {{id}}",
    fallbackProject: "Verkefni {{id}}",
  },
  detail: {
    requestedBy: "umbeðið af",
    requestTitleLabel: "Titill beiðni",
    requestLabel: "Beiðni",
    submitted: "Sent inn",
    requestedFields: "Umbeðnir dálkar",
    filterCriteria: "Síunarskilyrði",
    processingNotes: "Athugasemdir umsækjanda",
    reviewNotes: "Athugasemdir yfirferðar",
    files: {
      uploadData: "Hlaða upp gögnum",
      label: "Skrár",
      notUploadedYet:
        "Ekki hlaðið upp ennþá — þú verður beðin(n) um að hlaða upp þegar þessi beiðni hefur verið samþykkt.",
      requestedFiles: "Umbeðnar skrár (1)",
    },
    sources: {
      forwardedTo: "Framsent til",
      recipientHeader: "Viðtakandi",
      forwardedHeader: "Framsent",
      statusHeader: "Staða",
      notesHeader: "Athugasemdir",
      unknownRecipient: "Óþekkt",
      orgSuffix: "(stofnun)",
      status: {
        pending: "Í vinnslu",
        fulfilled: "Afgreitt",
        declined: "Hafnað",
      },
    },
    archived: {
      noteBefore:
        "Þetta verkefni er varðveitt og ritvarið. Endurvektu það í Stillingum verkefnis -`",
      noteAfter: "` Verkefnastýringu til að geta brugðist við þessari beiðni.",
    },
    actions: {
      notesPlaceholder: "Bættu við athugasemdum (nauðsynlegt til að hafna)…",
      approve: "Samþykkja",
      reject: "Hafna",
      rejectRequiresNotes: "Athugasemdir eru nauðsynlegar til að hafna beiðni",
      forward: "Framsenda til gagnabirgis",
      forwardHint: "Biddu gagnahleðslumann eða verkefnisstjóra um að útvega gögnin fyrir þessa beiðni",
    },
  },
};

export default adminRequestsSplitView;
